import type { ComponentProps } from 'react'

import { useTranslation } from 'react-i18next'

import { Icon } from '@/shared/components/icon'
import Paginacao from '@/shared/components/paginacao'
import { Button } from '@/shared/components/ui'
import { useSearchParamsWithTimestamp } from '@/shared/hooks'

interface ListaLeadsRepresadosFooterProps extends ComponentProps<typeof Button> {
  totalItens: number
  paginaCorrente: number
}

const ListaLeadsRepresadosFooter = ({ totalItens, paginaCorrente, ...props }: ListaLeadsRepresadosFooterProps) => {
  const { t } = useTranslation('leads-represados')
  const { filters, setFilters } = useSearchParamsWithTimestamp()

  const handleMudarPagina = (pagina: number, quantidadeItens: number) => {
    setFilters({ ...filters, paginaCorrente: pagina.toString(), tamanhoDaPagina: quantidadeItens.toString() })
  }

  const itensPorPaginaInicial = filters.tamanhoDaPagina ? Number(filters.tamanhoDaPagina) : undefined

  return (
    <div className="mx-auto flex w-full flex-col gap-4 sm:max-w-4xl">
      <div className="border-muted mx-auto -mt-2 w-full justify-end space-y-4 rounded-sm rounded-t-none border-t-1 bg-white p-4 shadow-xs sm:flex">
        <Button className="h-12 w-35" showLoadingText={false} type="button" {...props}>
          <Icon name="plus" />
          {t('pages.consulta.footer.novo_registro')}
        </Button>
      </div>
      <Paginacao
        onMudarPagina={handleMudarPagina}
        totalItens={totalItens}
        itensPorPaginaInicial={itensPorPaginaInicial}
        paginaInicial={paginaCorrente}
      />
    </div>
  )
}

export { ListaLeadsRepresadosFooter }
